import BaseCrudRepository from '@/repositories/BaseCrudRepository';
import ProductImage from '@/repositories/data/webshop/ProductImage';
import HttpClient from '@/util/http/HttpClient';

export default class ProductImageRepository extends BaseCrudRepository<
    { [key: string]: any[] },
    ProductImage,
    ProductImage
> {
    constructor(client: HttpClient) {
        super(client, 'rest/admin/product-image');
    }
}
